import { render, staticRenderFns } from "./TgLiveInfoCard.vue?vue&type=template&id=d8001536&"
import script from "./TgLiveInfoCard.vue?vue&type=script&lang=js&"
export * from "./TgLiveInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports